import React, { useMemo } from 'react';
import './AirlineFilterBar.css';

/**
 * AirlineFilterBar - Horizontal pills showing airlines with prices
 * Matches SanoGrid design exactly
 */
const AirlineFilterBar = ({ flights, selectedAirlines, onAirlinesChange }) => {
  
  // Get unique airlines with their lowest prices
  const airlineOptions = useMemo(() => {
    if (!flights || flights.length === 0) return [];
    
    const airlineMap = new Map();
    
    flights.forEach(flight => {
      const code = flight.airlineCode || flight.carrierCode;
      const name = flight.airline || code;
      const price = flight.price;
      
      if (!airlineMap.has(code)) {
        airlineMap.set(code, { code, name, price });
      } else {
        const existing = airlineMap.get(code);
        if (price < existing.price) {
          airlineMap.set(code, { code, name, price });
        }
      }
    });
    
    return Array.from(airlineMap.values()).sort((a, b) => a.price - b.price);
  }, [flights]);

  if (airlineOptions.length === 0) return null;

  const isAllSelected = selectedAirlines.length === 0;

  const handleToggle = (airlineCode) => {
    if (airlineCode === 'all') {
      onAirlinesChange([]);
    } else {
      const newSelection = selectedAirlines.includes(airlineCode)
        ? selectedAirlines.filter(a => a !== airlineCode)
        : [...selectedAirlines, airlineCode];
      onAirlinesChange(newSelection);
    }
  };

  return (
    <div className="airline-filter-bar">
      {/* All Airlines Button */}
      <button
        className={`afl-btn ${isAllSelected ? 'active' : ''}`}
        onClick={() => handleToggle('all')}
      >
        All Airlines
      </button>

      {/* Individual Airline Buttons */}
      {airlineOptions.map(airline => (
        <button
          key={airline.code}
          className={`afl-btn ${selectedAirlines.includes(airline.code) ? 'active' : ''}`}
          onClick={() => handleToggle(airline.code)}
        >
          {airline.name} • ${airline.price}
        </button>
      ))}
    </div>
  );
};

export default AirlineFilterBar;